// Individual password validation checks
export const getPasswordChecks = (password, name) => {
  return {
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    noName: name ? !password.toLowerCase().includes(name.toLowerCase()) : true
  };
};

// Calculate password strength based on checks
export const getPasswordStrength = (password, name) => {
  if (!password.length) return null;
  
  const checks = getPasswordChecks(password, name);
  const validChecks = Object.values(checks).filter(Boolean).length;
  const totalChecks = name ? 6 : 5;
  
  if (validChecks === totalChecks) {
    return { level: 'strong', text: 'Strong', color: 'var(--success-color)' };
  }
  if (validChecks >= totalChecks - 1) {
    return { level: 'good', text: 'Good', color: 'var(--warning-color)' };
  }
  if (validChecks >= 3) {
    return { level: 'fair', text: 'Fair', color: 'var(--warning-color)' };
  }
  return { level: 'weak', text: 'Weak', color: 'var(--danger-color)' };
};

// Original validation function for form submission
export const validatePassword = (password, name) => {
  if (password.length < 8) {
    return "Password must be at least 8 characters long";
  }
  if (!/[0-9]/.test(password)) {
    return "Password must include at least one digit (0-9)";
  }
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    return "Password must include at least one special character (@#$%^&*)";
  }
  if (name && password.toLowerCase().includes(name.toLowerCase())) {
    return "Password should not contain your name";
  }
  if (!/[A-Z]/.test(password)) {
    return "Password must include at least one uppercase letter (A-Z)";
  }
  if (!/[a-z]/.test(password)) {
    return "Password must include at least one lowercase letter (a-z)";
  }
  return null;
};


